import React, { useEffect, useState } from "react";
import { Button, Col } from "react-bootstrap";
import NotificationService from "../../services/notification.service";
import { NotificationTable } from "../allTables/allTable";
import { useNavigate } from "react-router-dom";

const FootballNotification = () => {
  const navigate = useNavigate();
  const newPage = localStorage.getItem("footballNotificationPage");
  const newData = localStorage.getItem("footballNotificationData");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dataPerPage, setDataPerPage] = useState(
    newData !== null ? newData : 10
  );
  const [pageNumber, setPageNumber] = useState(newPage !== null ? newPage : 1);
  const [totalRows, setTotalRows] = useState("");

  const getAllUserData = async () => {
    const newPageNumber = localStorage.getItem("footballNotificationPage");
    if (newPageNumber === null) {
      localStorage.setItem("footballNotificationPage", 1);
    }
    const newPageData = localStorage.getItem("footballNotificationData");
    if (newPageData === null) {
      localStorage.setItem("footballNotificationData", 10);
    }
    const response = await NotificationService.getAllNotification(
      pageNumber,
      dataPerPage,
      "football"
    );
    setData(response.data.data);
    setTotalRows(response.data.totalRecord);
  };

  useEffect(() => {
    getAllUserData();
    localStorage.setItem("footballNotificationPage", pageNumber);
    localStorage.setItem("footballNotificationData", dataPerPage);
  }, [pageNumber, dataPerPage]);

  const handlePerPageChange = (newPerPage, newPageNumber) => {
    setIsLoading(true);
    setDataPerPage(newPerPage);
    setPageNumber(newPageNumber);
    setIsLoading(false);
  };

  const handlePageChange = (newPageNumber) => {
    setIsLoading(true);
    setPageNumber(newPageNumber);
    setIsLoading(false);
  };

  return (
    <>
      <div className="page-header2"></div>
      <div className="row">
        <Col
          sm={12}
          md={6}
          lg={12}
          xl={12}
          className="ms-auto mt-auto d-flex"
          style={{ justifyContent: "end", alignItems: "baseline" }}
        >
          <div
            className="me-auto d-flex justify-content-start"
            style={{ fontWeight: 600, fontSize: "20px", marginBottom: "10px" }}
          >
            FOOTBALL NOTIFICATION
          </div>
          <div
            className="custom-card text-end  pointer"
            style={{ marginRight: "18px", marginTop: "4px" }}
          >
            <Button
              className="text-white"
              onClick={() => navigate("/football-notification/add")}
              style={{ marginLeft: "15px", marginTop: "-3px" }}
            >
              <i className="fas fa-plus"></i> &nbsp; Add Notification
            </Button>
          </div>
        </Col>
      </div>
      <NotificationTable
        data={data}
        totalRows={totalRows}
        dataPerPage={dataPerPage}
        handlePerPageChange={handlePerPageChange}
        handlePageChange={handlePageChange}
        isLoading={isLoading}
        getAllUser={getAllUserData}
        type="football"
        getAllUserData={getAllUserData}
        pageNumber={pageNumber}
      />
    </>
  );
};

export default FootballNotification;
